import { Vue, Component } from "vue-property-decorator";

// vue-plotly bundles the same plotly.js instance; require it for the resize API.
const Plotly = require("plotly.js");

/**
 * Keeps vue-plotly charts fitted to their container.
 */
@Component
export default class PlotlyResizeMixin extends Vue {
    private chartResizeObserver: any = null;

    mounted() {
        const RO = (window as any).ResizeObserver;
        if (typeof RO !== "undefined") {
            this.chartResizeObserver = new RO(() => {
                requestAnimationFrame(() => this.resizeCharts());
            });
            this.chartResizeObserver.observe(this.$el);
        }
    }

    beforeDestroy() {
        if (this.chartResizeObserver) {
            this.chartResizeObserver.disconnect();
            this.chartResizeObserver = null;
        }
    }

    /**
     * Re-fit each named vue-plotly ref to its current container width.
     */
    refitPlotly(refNames: string[]) {
        for (const refName of refNames) {
            const el = (this.$refs[refName] as any)?.$el;
            if (el && el.clientWidth > 0) {
                Plotly.relayout(el, { width: el.clientWidth });
            }
        }
    }

    /** A safe placeholder that does nothing, so that tabs which haven't filled it in yet don't error.**/
    resizeCharts() {
        /* no-op until a component overrides it */
    }
}
